'use client';

import ArticleCard from '@shared/Articles/ArticlePage/ArticleCard/ArticleCard';
import {articleTestIds} from '@shared/Articles/ArticleTestIds';
import {NewPagination} from '@shared/NewPagination';
import cn from '@sindresorhus/class-names';

import {ArticlesPaginationConfig} from '@shared/Articles/constants';

import {ArticleType} from '@strapi/types';

import {useArticlesAnalytics} from '@web-landing/analytics/hooks/useArticlesAnalytics';

import styles from './index.module.scss';

type Props = {
  articles: ArticleType[];
  pagination: {
    page: number;
    pageSize: number;
    pageCount: number;
    total: number;
  };
  pageNumber: number;
  baseBath?: string;
  enableTimeToReadInfo?: boolean;
};

export const ProStoreArticles = ({
  pagination,
  articles,
  pageNumber,
  baseBath = '/prostore',
  enableTimeToReadInfo,
}: Props) => {
  const {compilationCardClick, articleCardClick} = useArticlesAnalytics();

  const handleArticleClickAnalytics = (article_name: string) => {
    if (baseBath === '/prostore') {
      compilationCardClick();
    }

    articleCardClick(article_name);
  };

  return (
    <>
      <div
        className={styles.cards}
        data-testid={articleTestIds.proStorePageArticles}
      >
        {articles.map((card) => (
          <ArticleCard
            onArticleClick={() => handleArticleClickAnalytics(card.cardTitle)}
            card={card}
            key={card.id}
            articleUrl={
              card.source === 'devBlog' ? 'developer/blog' : 'prostore'
            }
            enableTimeToReadInfo={enableTimeToReadInfo}
          />
        ))}
      </div>
      {pagination.pageCount > 1 && (
        <div className={cn(styles.pagination, styles.new)}>
          <>
            <hr className={styles.divider} />
            <NewPagination
              currentPage={pageNumber}
              totalPages={pagination.pageCount}
              basePath={baseBath}
              urlVariant="page/x"
              responsiveConfig={ArticlesPaginationConfig}
            />
          </>
        </div>
      )}
    </>
  );
};
